<template>

    <v-step :step="step" title="Options">

        <v-form-group v-if="campaign.type === 'automatic'" label="Audience" caption="Limit who may enter this campaign.">
            <v-selector
                class="w-500"
                :model="campaign.segment_id"
                :items="segments | segmentsForSelector"
                @input="setParam({ segment_id: $event })">
            </v-selector>
        </v-form-group>

        <v-form-group label="Smart Sending" :caption="smartSendingCaption">
            <v-checkbox label="Use Smart Sending" :model="campaign.smart_sending" @input="setParam({ smart_sending: $event })" />
        </v-form-group>

    </v-step>

</template>

<script>

import Step from './Step';

export default {

    components: {
        'v-step': Step,
    },

    props: {
        step: {
            type: Number,
            default: 1,
        },
    },

    computed: {

        campaign() {
            return this.$store.getters['campaign/campaign'];
        },

        segments() {
            return this.$store.getters.project.segments;
        },

        smartSendingCaption() {
            let interval = this.project.send_interval === 1 ? 'day' : 'days';
            return `Customers can only be emailed once every ${this.project.send_interval} ${interval} if Smart Sending is enabled.`;
        },

    },

    methods: {

        setParam(param) {
            this.$store.commit('campaign/setParam', param);
        },

    },

}

</script>
